// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__dM2Oh","header":"PatientBlock_header__3W2sQ","label":"PatientBlock_label__3xoYM","option":"PatientBlock_option__3DPnU"};